declare var FizConfig: {
  GOOGLE_MAPS_V3 : string
  CONFIG_PARTNER_TYPE : string
  ANDROID_DOWNLOAD_URL : string
  IPHONE_DOWNLOAD_URL : string
  WINDOWS_DOWNLOAD_URL : string
  VERSION : string
  serviceWorker:true,

  termsURL :string
  faqURL :string
  defaultLocation :{latitude :number,longitude :number,zoom :number}
  invitequota :number
  defaultColor :string
  GIPHY_API_KEY :string
  API_BASE_URL :string
  websocketNotification: boolean
  tzProfile: boolean
  LAUNCHDARKLY_CLIENTID : string
  GOOGLE_ANALYTICS_GTM : string
};

FizConfig.termsURL = FizConfig.termsURL || "terms.html";
FizConfig.faqURL = FizConfig.faqURL || "faq.html";

FizConfig.defaultColor =  "#4784EC";

//defaultLocation
FizConfig.defaultLocation = {latitude:48.85,longitude:2.33,zoom:4};

FizConfig.invitequota = 200;

if(!window.fetch){
  FizConfig.GIPHY_API_KEY = undefined;
}

export default FizConfig;